module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "register"
  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "offset-sm2": "",
      "sm8": "",
      "offset-md3": "",
      "md6": "",
      "offset-lg4": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register($event)
      }
    }
  }, [_c('v-text-input', {
    attrs: {
      "required": "",
      "name": "firstName",
      "id": "firstName",
      "label": "First Name"
    },
    model: {
      value: (_vm.userModel.firstname),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "firstname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "userModel.firstname"
    }
  }), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "required": "",
      "name": "lastName",
      "id": "lastName",
      "label": "Last Name"
    },
    model: {
      value: (_vm.userModel.lastname),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "lastname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "userModel.lastname"
    }
  }), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "required": "",
      "type": "password",
      "name": "password",
      "id": "password",
      "label": "Password"
    },
    model: {
      value: (_vm.userModel.password),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "password", $$v)
      },
      expression: "userModel.password"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validatePass),
      expression: "validatePass"
    }],
    staticClass: "error"
  }, [_vm._v("Passwords don't match.")]), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "required": "",
      "type": "password",
      "name": "password",
      "id": "validatePassword",
      "label": "Confirm Password"
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "required": "",
      "id": "email",
      "name": "email",
      "type": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.userModel.email),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "userModel.email"
    }
  }), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "required": "",
      "id": "school",
      "name": "school",
      "label": "School"
    },
    model: {
      value: (_vm.userModel.school),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "school", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "userModel.school"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "required": "",
      "options": _vm.genderOptions,
      "id": "gender",
      "label": "Gender",
      "name": "gender"
    },
    model: {
      value: (_vm.userModel.gender),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "gender", $$v)
      },
      expression: "userModel.gender"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.dietaryOptions,
      "id": "dietary",
      "label": "Dietary",
      "name": "dietary"
    },
    model: {
      value: (_vm.userModel.dietary),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "dietary", $$v)
      },
      expression: "userModel.dietary"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-input"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mlh-check-box"
  }, [_c('v-checkbox', {
    attrs: {
      "required": "",
      "value-v": "yes",
      "id": "mlhCode",
      "name": "mlhCode",
      "label": "I Agree to MLH Code of Conduct"
    },
    model: {
      value: (_vm.userModel.checkMlh),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "checkMlh", $$v)
      },
      expression: "userModel.checkMlh"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "id": "mlhCodeHref",
      "href": _vm.mlhCodeUrl,
      "target": "_blank"
    }
  }, [_vm._v("(link)")]), _vm._v(" "), _c('div', [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "registerBtn"
    }
  }, [_c('v-btn', {
    staticClass: "vt-submit-btn",
    attrs: {
      "ripple": {
        class: 'teal--text'
      },
      "type": "submit",
      "round": true,
      "loading": _vm.submitState
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n                        Submit\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.submitError))])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1afe0dd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 82
// module chunks = 1